module.exports = __webpack_public_path__ + "img/ornellagianessi.0265202d.jpeg";